module.exports = __webpack_public_path__ + "static/media/content-zero.07de57ba.svg";